<template>
<div class="star">
    <div>
        <span :class="{styleStar:styleStar!=null}">{{label}}</span>
    </div>
    <div v-if="display == true">
        <fa-icon :class="{color: this.occurant>1 || this.occurant==1}" :icon="{ prefix: 'fas', iconName: 'star' }" />
        <fa-icon :class="{color: this.occurant>2 || this.occurant==2}" :icon="{ prefix: 'fas', iconName: 'star' }" />
        <fa-icon :class="{color: this.occurant>3 || this.occurant==3}" :icon="{ prefix: 'fas', iconName: 'star' }" />
        <fa-icon :class="{color: this.occurant>4 || this.occurant==4}" :icon="{ prefix: 'fas', iconName: 'star' }" />
        <fa-icon :class="{color: this.occurant==5}" :icon="{ prefix: 'fas', iconName: 'star' }" />
    </div>            
</div>
</template>

<script>
export default {
    props:{
        label:{
            type:String
        },
        occurant:{
            type:Number
        },
        styleStar:{
            type:String,
            default:null
        },
        display: {
            type: Boolean
        }
    }
}
</script>

<style scoped lang="scss">
.star{
    display: flex;
    table {
        width: 60%;
    }
    span{
        margin-right: 10px;
    }
    .styleStar{
        color: #22ABC5;
        font-size: 16px;
        
    }
    .color{
        color:  #ff8c00;
    }
}

</style>